/**
 * Stacked gift-fund sheet actions. Icon and label share one centered row.
 *
 * Belongs here: primary/secondary CTA layout for both gift-fund sheets.
 * Does not belong here: copy, mailto, or WhatsApp.
 */
import { PrimaryButton } from '../../../components/execution/PrimaryButton'
import { SecondaryButton } from '../../../components/execution/SecondaryButton'
import RenderHTML from '../../../components/ui-components/RenderHTML'

export type PpfasGiftFundSheetCta = {
  testLocator: string
  label: string
  onClick: () => void
  variant: 'primary' | 'secondary'
  iconSvg?: string
  isDisabled?: boolean
}

export function PpfasGiftFundSheetCtas({ ctas }: { ctas: PpfasGiftFundSheetCta[] }) {
  return (
    <div className="flex w-full flex-col gap-3">
      {ctas.map((cta) => {
        if (cta.variant === 'primary') {
          return (
            <PrimaryButton
              key={cta.testLocator}
              testLocator={cta.testLocator}
              label={cta.label}
              primaryButtonClassName="!flex !h-[56px] !items-center !justify-center !pb-0 !pb-[11px] text-[14px]"
              isDisabled={cta.isDisabled}
              onClick={cta.onClick}
            >
              <span className="inline-flex items-center justify-center gap-2">
                {cta.iconSvg ? (
                  <span aria-hidden="true" className="flex shrink-0 items-center">
                    <RenderHTML innerHTMLText={cta.iconSvg} className="flex [&_svg]:block" />
                  </span>
                ) : null}
                <span className="leading-none mb-[1.5px]">{cta.label}</span>
              </span>
            </PrimaryButton>
          )
        }

        return (
          <SecondaryButton
            key={cta.testLocator}
            testLocator={cta.testLocator}
            label={cta.label}
            secondaryButtonClassName="!flex !h-[56px] !items-center !justify-center text-[14px]"
            onClick={cta.onClick}
          />
        )
      })}
    </div>
  )
}
